import { i18n } from "app/i18n/i18n";
import { isPublicPath } from "lib/routing";

export function createAnalystQueryBody(queryString) {
  const filters = filtersFromQueryString(queryString);
  const from = queryString.from ? { from: queryString.from } : {};
  const source = isAnalystProfile(queryString) ? profileFieldList : directoryFieldList;
  const aggs = createAggs(queryString);
  const post_filter = createPostFilter(queryString);
  const sort = [
    { "speciality.group.en.keyword": { order: "desc" } },
    { "speciality.speciality.en.keyword": { order: "asc" } },
    { sortOrder: { order: "asc" } },
    { lastName: { order: "asc" } },
  ].filter((i) => i);

  let body = {
    size: 500,
    ...from,
    query: {
      bool: {
        must: filters,
      },
    },
    sort,
    _source: source,
    aggs,
    post_filter,
  };

  return JSON.stringify(body);
}

function filtersFromQueryString({
  Analyst,
  email,
  analystSurvey,
  assetClass,
  product,
  q,
  region,
  speciality,
  ...queryString
}) {
  let filters = [
    { term: { language: i18n.getLanguage() } },
    queryString["analysts.id"] && { term: { categoryId: queryString["analysts.id"] } },
    Analyst && { term: { "fullName.en": Analyst } },
    email && { term: { "email.keyword": email } },
    analystSurvey && { term: { analystSurvey: analystSurvey } },
    assetClass && { term: { "assetClasses.name.en": assetClass } },
    product && { term: { "assetTypes.name.en": product } },
    q && { query_string: { query: q + "*" } },
  ];

  if (isPublicPath()) {
    //  public version only shows Japan analysts
    filters.push({ term: { "regions.name.en": "Japan" } });
  }

  // speciality query param filters both Group (EQ/Macro) and Specialism
  if (speciality === "Macro" || speciality === "Equity") {
    filters.push({ term: { "speciality.group.en.keyword": speciality } });
  }

  return filters.filter((i) => i); // remove empty filters
}

const createAggs = (queryString) => ({
  speciality: {
    filter: {
      bool: {
        [mustIf(queryString.region)]: [
          {
            term: { "regions.name.en": queryString.region || "" },
          },
        ],
      },
    },
    aggs: {
      speciality: {
        terms: {
          field: "speciality.speciality.en.keyword",
          size: 50,
        },
      },
    },
  },
  region: {
    filter: {
      bool: {
        [mustIf(queryString.speciality)]: [
          { term: { "speciality.speciality.en.keyword": queryString.speciality || "" } },
        ],
      },
    },
    aggs: {
      region: {
        terms: {
          field: "regions.name.en",
          size: 5,
        },
      },
    },
  },
});

const createPostFilter = (queryString) => ({
  bool: {
    must: [
      ...(queryString.speciality ? [{ term: { "speciality.speciality.en.keyword": queryString.speciality } }] : []),
      ...(queryString.region ? [{ term: { "regions.name.en": queryString.region } }] : []),
    ],
  },
});

const isAnalystProfile = (qs) => qs["Analyst"] || qs["analysts.id"];
const profileFieldList = "*";
const directoryFieldList = [
  "fullName",
  "categoryId",
  "title",
  "department",
  "ranking",
  "regions",
  "imageURL",
  "speciality",
  "email",
];

const mustIf = (bool) => (bool ? "must" : "must_not");
